export default __webpack_public_path__ + "static/media/SX.a140039e.svg";